import { useAxiosPost } from './usePost';
import { RegistUserResponse } from '@project_bamboo/shared';

const useSendCorrectMessage = () => {
  return useAxiosPost<RegistUserResponse>('/product/send-correct-message');
};

export default useSendCorrectMessage;
